import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddSectiuniPubliceComponent } from './add-sectiuni-publice/add-sectiuni-publice.component';
import { EditSectiuniPubliceComponent } from './edit-sectiuni-publice/edit-sectiuni-publice.component';
import { SectiuniPubliceComponent } from './sectiuni-publice.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        SectiuniPubliceComponent,
        AddSectiuniPubliceComponent,
        EditSectiuniPubliceComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [SectiuniPubliceComponent]
})
export class SectiuniPubliceModule { }
